import Highway from '@dogstudio/highway';
import WknPlyr from '../modules/wkn-plyr';
import { mouseMovefn } from 'utils.js';
export default class etudiantsRenderer extends Highway.Renderer {

	onEnter() {

		this.DOM = { view: this.wrap.lastElementChild };


		// const h1Anim = new TimelineMax({paused:true, onComplete:() => {
		// }})
		// h1Anim.fromTo(document.querySelector(".Page__header h1 .hided"), 0.3, {x:"-105%"}, {x:"0%", ease:Power3.easeInOut}, 2.9);
		// h1Anim.fromTo(document.querySelector(".Page__header h1 .hided em"), 0.3, {x:"105%"}, {x:"0%", ease:Power3.easeInOut}, 2.9);
		// h1Anim.play();


		var experiences__swiper = new Swiper('.experiences__swiper', {
			// Optional parameters
			slidesPerView: "auto",
			loop: false,
			spaceBetween: 20,
			grabCursor: false,
			  on: {
			    init: function (swiper) {
			      swiper.slides.forEach((slide) => {
			      	const player = new Plyr(slide.querySelector('.video__player')) 
					player.on('play', event => {
						slide.querySelector('.plyr__video__poster').classList.add('playing');
					});
					player.on('pause', event => {
						slide.querySelector('.plyr__video__poster').classList.remove('playing');
					});


			      })
			    },
			  }
		})

		var apply__swiper = new Swiper('.apply__swiper', {
			slidesPerView: "auto",
			loop: false,
			spaceBetween: 20,
			grabCursor: false,
			  on: {
			    init: function (swiper) {
			      swiper.slides.forEach((slide) => {
			      	const player = new Plyr(slide.querySelector('.video__player')) 
					player.on('play', event => {
						slide.querySelector('.plyr__video__poster').classList.add('playing');
					});
					player.on('pause', event => {
						slide.querySelector('.plyr__video__poster').classList.remove('playing');
					});
			      })
			    },
			  }
		})

		var schools__swiper = new Swiper('.schools__swiper', {
			// Optional parameters
			slidesPerView: "auto",
			loop: true,
			spaceBetween: 80,
			grabCursor: true,
			breakpoints: {
				768: {
					spaceBetween: 80
				}
			},
		})



		// $('.videos__swiper .swiper-slide').magnificPopup({
		// 	delegate: 'a', // child items selector, by clicking on it popup will open
		// 	type: 'inline'
		// });

		const rse__player = new Plyr('.video__player', {});
		// console.log(rse__player);
		rse__player.on('play', event => {
			console.log("hello");
			document.querySelector('#video__rse .plyr__video__poster').classList.add('playing');
		});
		rse__player.on('pause', event => {
			document.querySelector('#video__rse .plyr__video__poster').classList.remove('playing');
			console.log("hello2");
		});


	}

	onEnterCompleted(){



	}

}
